// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2eids","title":"AfterFrontImage_title__Qur_T"};